import React from 'react';
import Icon from './Icon';

const ImportIcon = (props) => (
    <Icon {...props}>
        <path
            d="M4 14V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V14M12 14V3M12 3L7.5 7.5M12 3L16.5 7.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ImportIcon;
